export default __webpack_public_path__ + "static/media/powerSupply2.70ba9d78.svg";